import { useAuth } from "../context/AuthContext";
import { useMaintenance } from "../context/MaintenanceContext";
import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";

export default function MaintenanceBanner() {
  const { user } = useAuth();
  const { enabled } = useMaintenance();
  if (!enabled || !user || user.role !== "admin") return null;
  return (
    <div
      className="w-full bg-[#E65F2B] text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-3 z-50"
      data-testid="maintenance-banner"
    >
      <Wrench className="h-4 w-4 shrink-0" />
      <span>Maintenance mode is ON — public access is blocked.</span>
      <Link
        to="/admin"
        className="underline underline-offset-2 hover:no-underline font-bold"
        data-testid="maintenance-banner-link"
      >
        Manage in Admin →
      </Link>
    </div>
  );
}
